const itemIds = {
	LogosMedia: [
		'306960',
		'306952',
		'306951',
		'306950',
		'306923',
		'306922',
		'306921',
		'306920',
		'306902',
		'306901',
		'306900',
		'306899',
		'306880',
		'306878',
		'306877',
		'306876',
		'306875',
		'306849',
		'306848',
		'306847',
	],
	NT156: [
		'337774',
		'337799',
		'337806',
		'337823',
		'338764',
		'338765',
		'338767',
		'338768',
		'338842',
		'339276',
		'339277',
		'339298',
		'339302',
		'339303',
		'339732',
		'339842',
	],
	NT211: [
		'334534',
		'329469',
		'329475',
		'329484',
		'333199',
		'333208',
		'331960',
		'331924',
		'334419',
		'330682',
		'330674',
		'329477',
		'331950',
		'330675',
		'330679',
		'330677',
		'330676',
		'329489',
		'330671',
		'333201',
		'333219',
		'330698',
		'333202',
		'334585',
		'333204',
		'333213',
		'330735',
		'331954',
		'333215',
		'330683',
		'331917',
		'333187',
		'331925',
		'334441',
		'334418',
		'334416',
		'329482',
		'334443',
		'334582',
		'334440',
		'329467',
		'333217',
		'333207',
		'329468',
		'331958',
		'331908',
		'329486',
		'334442',
		'331916',
		'334531',
		'329562',
		'331947',
		'329474',
		'334529',
		'331926',
		'329483',
		'329479',
		'334415',
		'333224',
		'331911',
		'330687',
		'330736',
		'347032',
		'346690',
		'346689',
		'347208',
		'346868',
		'347205',
		'347373',
		'346692',
		'347366',
		'346815',
	],
	LaunchItemId: '358606',
};
export default itemIds;
